import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useOpApprove from '@opsbase/react-gql-hooks/op/useOpApprove';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function OpApproveDialog() {
    const { id } = useParams();
    const { raise } = useNotificationActions();
    const { goBack } = useNav();
    const opApprove = useOpApprove();
    const text = i18n.t('confirm-op-approve');
    const approveText = i18n.t('approve');
    const cancelText = i18n.t('close');
    const handleAction = useCallback(async () => {
        raise(opApprove({ id }).then(goBack), i18n.t('op-approve-successful')).catch(doNothing);
    }, [goBack, opApprove, id, raise]);
    return (React.createElement(ConfirmDialog, { onConfirm: handleAction, agreeText: approveText, notAgreeText: cancelText, color: Palette.positive },
        React.createElement(Text, null, text)));
}
export default OpApproveDialog;
